// 待客户端补充
export var MediaErrorCode;
(function (MediaErrorCode) {
    /**
     * 未知错误
     */
    MediaErrorCode[MediaErrorCode["ErrorUnknown"] = 23000] = "ErrorUnknown";
    /**
     * 图片上传失败
     */
    MediaErrorCode[MediaErrorCode["ImageUploadError"] = 23005] = "ImageUploadError";
    /**
     * 图片下载失败
     */
    MediaErrorCode[MediaErrorCode["ImageDownloadError"] = 23006] = "ImageDownloadError";
})(MediaErrorCode || (MediaErrorCode = {}));
//# sourceMappingURL=mega-media-service.protocol.js.map